import LockIcon from './LockIcon';

export { LockIcon };

export default LockIcon;
